import { getSceneOrderListReq } from "../../api/swap.js";
import * as types from "../mutation-types";

// initial state
const state = {
  sceneOrders: [],
  scenepageSize: 10,
  scenepageIndex: 1,
  scenemaxPageSize: 1,
  scenebeginTime: "", // 起始时间
  sceneendTime: "", // 结束时间
  scenebusinesslineIds: "", // 业务线id
  sceneorderNodeIds: "", // 订单状态
  scenematchingFields: "", // 平台订单id或业务订单id或手机号
  scenecustomerLabelIds: "", // 客户标签
  scenedataType: "", // 数据类型
  scenebusinessType: "", // 业务状态
  scenecheckType: "",
};

// getters
const getters = {
  sceneOrders: (state) => state.sceneOrders,
  sceneisOrderPageEnd: (state) => state.scenepageIndex >= state.scenemaxPageSize,
  scenebeginTime: (state) => state.scenebeginTime,
  sceneendTime: (state) => state.sceneendTime,
  scenebusinesslineIds: (state) => state.scenebusinesslineIds,
  sceneorderNodeIds: (state) => state.sceneorderNodeIds,
  scenematchingFields: (state) => state.scenematchingFields,
  scenecustomerLabelIds: (state) => state.scenecustomerLabelIds,
  scenedataType: (state) => state.scenedataType,
  scenebusinessType: (state) => state.scenebusinessType,
  scenecheckType: (state) => state.scenecheckType,
};
// mutations
const mutations = {
  // 设置场景推广订单列表
  [types.RECEIVE_SCENE_ORDER_LIST](state, { list }) {
    state.sceneOrders = list;
  },
  // 追加场景推广订单列表
  [types.APPEND_SCENE_ORDER_LIST](state, { list }) {
    if (list && list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        state.sceneOrders.push(list[i]);
      }
    }
  },
  // 设置最大页数
  [types.SET_ACCOUNT_ORDERS_MAXPAGESIZE](state, { pageCount }) {
    state.scenemaxPageSize = pageCount;
  },
  // 设置当前页数
  [types.SET_ACCOUNT_ORDERS_PAGEINDEX](state, { pageIndex }) {
    state.scenepageIndex = pageIndex;
  },
  // 显示订单应发佣金流程
  CHANGE_SCENE_ORDER_COMMISSION_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowDelayCommission = false;
      item.isShowDelayReward = false;
      item.isShowReward = false;
      item.isShowOrderState = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowCommission = !item.isShowCommission;
      } else {
        item.isShowCommission = false;
      }
    });
  },
  // 显示订单延迟应发佣金流程
  CHANGE_SCENE_ORDER_DELAY_COMMISSION_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowReward = false;
      item.isShowDelayReward = false;
      item.isShowOrderState = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowDelayCommission = !item.isShowDelayCommission;
      } else {
        item.isShowDelayCommission = false;
      }
    });
  },
  // 显示订单实发佣金流程
  CHANGE_SCENE_ORDER_REWARD_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowDelayCommission = false;
      item.isShowDelayReward = false;
      item.isShowOrderState = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowReward = !item.isShowReward;
      } else {
        item.isShowReward = false;
      }
    });
  },
  // 显示订单实发佣金流程
  CHANGE_SCENE_ORDER_DELAY_REWARD_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowDelayCommission = false;
      item.isShowReward = false;
      item.isShowOrderState = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowDelayReward = !item.isShowDelayReward;
      } else {
        item.isShowDelayReward = false;
      }
    });
  },
  // 显示订单下单经销商
  CHANGE_SCENE_ORDER_DEALER_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowDelayCommission = false;
      item.isShowReward = false;
      item.isShowDelayReward = false;
      item.isShowOrderState = false;
      if (item.orderID === id) {
        item.isShowDealer = !item.isShowDealer;
      } else {
        item.isShowDealer = false;
      }
    });
  },
  // 改变订单流程状态
  CHANGE_SCENE_ORDER_STEP_STATE(state, id) {
    state.sceneOrders.forEach((item) => {
      item.isShowCommission = false;
      item.isShowDelayCommission = false;
      item.isShowReward = false;
      item.isShowDelayReward = false;
      item.isShowDealer = false;
      if (item.orderID === id) {
        item.isShowOrderState = !item.isShowOrderState;
      } else {
        item.isShowOrderState = false;
      }
    });
  },
  // 显示应发原因
  CHANGE_SCENE_ORDER_POPOVER(state, id) {
    state.sceneOrders.forEach((item) => {
      if (item.orderID === id) {
        item.isShowPopover = !item.isShowPopover;
      } else {
        item.isShowPopover = false;
      }
    });
  },
  // 追加订单状态数据
  CHANGE_SCENE_ORDER_STEP_LIST(state, obj) {
    state.sceneOrders.forEach((item) => {
      if (item.orderID === obj.orderId) {
        item.orderStepList = obj.list;
      }
    });
  },
  SET_SCENE_ORDER_SEARCH_TIME(state, payload) {
    state.scenebeginTime = payload.beginTime;
    state.sceneendTime = payload.endTime;
  },
  SET_SEARCH_SCENE_ORDER_NODE(state, payload) {
    state.sceneorderNodeIds = payload.orderNodeIds;
    state.scenecustomerLabelIds = payload.customerLabelIds;
    state.scenedataType = payload.dataType;
    state.scenebusinesslineIds = payload.businesslineIds;
    state.scenebusinessType = payload.businessType;
  },
  SET_SEARCH_SCENE_ORDERID(state, payload) {
    state.scenematchingFields = payload.matchingFields;
    state.scenecheckType = payload.checkType;
  },
};

// actions
const actions = {
  async getSceneOrders({ commit, getters }) {
    commit(types.SET_ACCOUNT_ORDERS_PAGEINDEX, { pageIndex: 1 });
    let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/;
    let res1 = await getSceneOrderListReq({
      beginTime: getters.scenebeginTime,
      endTime: getters.sceneendTime,
      businesslineIds: getters.scenebusinesslineIds,
      orderNodeIds: getters.sceneorderNodeIds,
      matchingFields: getters.scenematchingFields,
      customerLabelIds: getters.scenecustomerLabelIds,
      businessType: getters.scenebusinessType,
      checkType: getters.scenecheckType,
      dataType: state.scenedataType,
      pageSize: state.scenepageSize,
      pageIndex: state.scenepageIndex,
    });
    commit(types.SET_ACCOUNT_ORDERS_MAXPAGESIZE, {
      pageCount: res1.data.result.list.pageCount,
    });
    if (getters.scenematchingFields) {
      let res2 = await getSceneOrderListReq({
        beginTime: getters.scenebeginTime,
        endTime: getters.sceneendTime,
        businesslineIds: getters.scenebusinesslineIds,
        orderNodeIds: getters.sceneorderNodeIds,
        customerLabelIds: getters.scenecustomerLabelIds,
        businessType: getters.scenebusinessType,
        checkType: getters.scenecheckType,
        matchingFields: getters.scenematchingFields.replace(reg, "$1****$2"),
        dataType: state.scenedataType,
        pageSize: state.scenepageSize,
        pageIndex: state.scenepageIndex,
      });
      var data = res1.data.result.list.orders.concat(
        res2.data.result.list.orders
      );
      const uniqueOrdersMap = new Map();
      data.forEach((item) => {
        if (!uniqueOrdersMap.has(item.orderID)) {
          uniqueOrdersMap.set(item.orderID, item);
        }
      });
      // 将 Map 转换回数组
      var list = Array.from(uniqueOrdersMap.values());
    } else {
      var list = res1.data.result.list.orders;
    }
    let newList = list.map((item) => {
      let newDealerList = item.dealerList.map((item1) => {
        return {
          ...item1,
          isShowDetail: false,
        };
      });
      return {
        ...item,
        dealerList: newDealerList,
        isShowOrderState: false,
        isShowCommission: false,
        isShowDealer: false,
        isShowReward: false,
        orderStepList: [],
        isShowPopover: false,
        isShowDelayCommission: false,
        isShowDelayReward: false,
      };
    });
    commit(types.RECEIVE_SCENE_ORDER_LIST, { list: newList });
  },
  // 加载更多
  async loadMoreSceneOrders({ commit, getters }) {
    const pageNo = state.scenepageIndex + 1;
    commit(types.SET_ACCOUNT_ORDERS_PAGEINDEX, { pageIndex: pageNo });
    let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/;
    let res1 = await getSceneOrderListReq({
      beginTime: getters.scenebeginTime,
      endTime: getters.sceneendTime,
      businesslineIds: getters.scenebusinesslineIds,
      orderNodeIds: getters.sceneorderNodeIds,
      customerLabelIds: getters.scenecustomerLabelIds,
      matchingFields: getters.scenematchingFields,
      businessType: getters.scenebusinessType,
      checkType: getters.scenecheckType,
      dataType: state.scenedataType,
      pageSize: state.scenepageSize,
      pageIndex: state.scenepageIndex,
    });

    if (getters.scenematchingFields) {
      let res2 = await getSceneOrderListReq({
        beginTime: getters.scenebeginTime,
        endTime: getters.sceneendTime,
        businesslineIds: getters.scenebusinesslineIds,
        orderNodeIds: getters.sceneorderNodeIds,
        customerLabelIds: getters.scenecustomerLabelIds,
        businessType: getters.scenebusinessType,
        checkType: getters.scenecheckType,
        matchingFields: getters.scenematchingFields.replace(reg, "$1****$2"),
        dataType: state.scenedataType,
        pageSize: state.scenepageSize,
        pageIndex: state.scenepageIndex,
      });
      var data = res1.data.result.list.orders.concat(
        res2.data.result.list.orders
      );
      const uniqueOrdersMap = new Map();
      data.forEach((item) => {
        if (!uniqueOrdersMap.has(item.orderID)) {
          uniqueOrdersMap.set(item.orderID, item);
        }
      });
      // 将 Map 转换回数组
      var list = Array.from(uniqueOrdersMap.values());
    } else {
      var list = res1.data.result.list.orders;
    }
    let newList = list.map((item) => {
      let newDealerList = item.dealerList.map((item1) => {
        return {
          ...item1,
          isShowDetail: false,
        };
      });
      return {
        ...item,
        dealerList: newDealerList,
        isShowOrderState: false,
        isShowCommit: false,
        isShowReward: false,
        isShowDealer: false,
        orderStepList: [],
        isShowPopover: false,
        isShowDelayCommission: false,
        isShowDelayReward: false,
      };
    });
    commit(types.APPEND_SCENE_ORDER_LIST, { list: newList });
  },
  // 设置查询订单时间
  setSearchSceneTime({ commit }, payload) {
    commit("SET_SCENE_ORDER_SEARCH_TIME", payload);
    return this.dispatch("getSceneOrders", { commit, getters });
  },
  // 设置查询订单节点
  setSearchSceneOrderNode({ commit }, payload) {
    commit("SET_SEARCH_SCENE_ORDER_NODE", payload);
    return this.dispatch("getSceneOrders", { commit, getters });
  },
  // 设置查询订单id
  setSearchSceneOrder({ commit }, payload) {
    commit("SET_SEARCH_SCENE_ORDERID", payload);
    return this.dispatch("getSceneOrders", { commit, getters });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/swapOrders.js